<template>
  <v-list-item
    :active="isActive"
    class="multiselect-checkbox-item"
    @click="onItemClick"
  >
    <template #prepend>
      <v-checkbox
        hide-details
        density="compact"
        :model-value="isActive"
        tabindex="-1"
        readonly
      />
    </template>
    <v-list-item-title class="text-truncate">{{ title }}</v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "MultiselectCheckboxItem",
  props: {
    itemProps: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    selectedValues: {
      type: Array,
      default: null,
    },
    itemValue: {
      type: [String, Number, Boolean],
      default: undefined,
    },
  },
  computed: {
    resolvedValue() {
      return this.itemValue ?? this.itemProps?.value;
    },
    isActive() {
      if (this.itemProps?.active !== undefined) {
        return Boolean(this.itemProps.active);
      }
      if (Array.isArray(this.selectedValues) && this.resolvedValue !== undefined) {
        return this.selectedValues.includes(this.resolvedValue);
      }
      return Boolean(this.itemProps?.isSelected ?? this.itemProps?.["aria-selected"]);
    },
  },
  methods: {
    onItemClick(event) {
      if (typeof this.itemProps?.onClick === "function") {
        this.itemProps.onClick(event);
      }
    },
  },
};
</script>

<style scoped>
.multiselect-checkbox-item :deep(.v-selection-control__input) {
  width: 20px !important;
  height: 20px !important;
}

.multiselect-checkbox-item :deep(.v-list-item-title) {
  font-size: 13.5px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.1px;
}
</style>
